import React from 'react';
import { StageComponentInterface } from '../../../../../../interfaces/pagebuilder';
import MbwStage from '../../../MBW/MBWStageComponent';
import { ModernStage } from '../../../TypeStage/StageComponent/StageComponent';

const StageUiComponent = ({ uiComponent }: { uiComponent: StageComponentInterface }) => {
  if (uiComponent.theme === 'mbw') return <MbwStage uiComponent={uiComponent} />;

  return <ModernStage uiComponent={uiComponent} />;
};

export default StageUiComponent;
